module.exports = __webpack_public_path__ + "img/img2.992674d8.png";